import React from 'react';
import { ITranslateProps, translate } from '../../../mixins/translate';
import { metaDataDefinition } from '../../../utils/data/fmecaDataDefinition';
import { ramsAOptions, ramsCOptions, ramsEcOptions, ramsEnvOptions, ramsPOptions, ramsROptions, ramsSOptions } from '../../../utils/data/rams';
import * as htmlHelper from '../../../utils/htmlHelper';
import { DataPanel, PanelSection } from '../../elements';
import { getMetadataValue } from '../Common/getMetadataValue';
import { RamsItem } from '../Common/RamsItem';
import { IFailureMode } from '../Interfaces/IFailureMode';

interface IConditionReportFmecaAnalysisProps extends ITranslateProps {
    failureMode: IFailureMode;
}

class ConditionReportFmecaAnalysisComponent extends React.Component<IConditionReportFmecaAnalysisProps, Record<string, unknown>> {
    constructor(props: IConditionReportFmecaAnalysisProps) {
        super(props);
    }

    public override render() {
        return (
            <DataPanel>
                {metaDataDefinition
                    .filter((i) => i.name !== 'Faaloorzaak anders')
                    .map((metaDataItem) => (
                        <div className="row" key={metaDataItem.name}>
                            <div className="col-md-12">
                                {metaDataItem.name === 'Faaloorzaak' && this.props.failureMode.metaData && (
                                    <>
                                        <b>{metaDataItem.name}:</b>&nbsp;
                                        {((this.props.failureMode.metaData as any)['Faaloorzaak'] === '4' &&
                                            (this.props.failureMode.metaData as any)['Faaloorzaak anders'] && (
                                                <>{(this.props.failureMode.metaData as any)['Faaloorzaak anders']}</>
                                            )) || (
                                            <>
                                                {getMetadataValue({
                                                    metaDataItem,
                                                    itemValue: (this.props.failureMode.metaData as any)['Faaloorzaak'],
                                                }) || ''}
                                            </>
                                        )}
                                    </>
                                )}

                                {metaDataItem.name === 'Bron van falen' && this.props.failureMode.metaData && (
                                    <>
                                        <b>{metaDataItem.name}:</b>&nbsp;
                                        {((this.props.failureMode.metaData as any)['Bron van falen'] === '7' &&
                                            (this.props.failureMode.metaData as any)['Bron van falen anders'] && (
                                                <>{(this.props.failureMode.metaData as any)['Bron van falen anders']}</>
                                            )) || (
                                            <>
                                                {getMetadataValue({
                                                    metaDataItem,
                                                    itemValue: (this.props.failureMode.metaData as any)['Bron van falen'],
                                                }) || ''}
                                            </>
                                        )}
                                    </>
                                )}
                                {metaDataItem.name === 'Gevolg van falen' && this.props.failureMode.metaData && (
                                    <>
                                        <b>{metaDataItem.name}:</b>&nbsp;
                                        <>
                                            {getMetadataValue({
                                                metaDataItem,
                                                itemValue: (this.props.failureMode.metaData as any)['Gevolg van falen'],
                                            }) || ''}
                                        </>
                                    </>
                                )}

                                {/* {metaDataItem.name === 'Bron van falen' && this.props.failureMode.metaData &&
                                <>
                                    <b>{metaDataItem.name}:</b>&nbsp;
                                        <>{(getMetadataValue(metaDataItem, (this.props.failureMode.metaData as any)['Bron van falen']) || '')}</>
                                </>
                            }
                            {metaDataItem.name === 'Gevolg van falen' && this.props.failureMode.metaData &&
                                <>
                                    <b>{metaDataItem.name}:</b>&nbsp;
                                        {(this.props.failureMode.metaData as any)['Gevolg van falen'] === '8' && (this.props.failureMode.metaData as any)['Gevolg van falen anders'] &&
                                        <>{(this.props.failureMode.metaData as any)['Gevolg van falen anders']}</>
                                        ||
                                        <>{(getMetadataValue(metaDataItem, (this.props.failureMode.metaData as any)['Gevolg van falen']) || '')}</>
                                    }
                                </>
                            } */}
                            </div>
                        </div>
                    ))}

                <PanelSection>
                    <RamsItem topLetter="R" ramsScore={this.props.failureMode.analysisRamsR} ramsOptions={ramsROptions} header="Betrouwbaarheid" />
                    <RamsItem topLetter="A" ramsScore={this.props.failureMode.analysisRamsA} ramsOptions={ramsAOptions} header="Beschikbaarheid" />
                    <RamsItem topLetter="S" ramsScore={this.props.failureMode.analysisRamsS} ramsOptions={ramsSOptions} header="Veiligheid" />
                    <RamsItem topLetter="C" ramsScore={this.props.failureMode.analysisRamsC} ramsOptions={ramsCOptions} header="Verzorgingsniveau" />
                    <RamsItem topLetter="E" ramsScore={this.props.failureMode.analysisRamsEc} ramsOptions={ramsEcOptions} header="Gevolgkosten" />
                    <RamsItem topLetter="E" ramsScore={this.props.failureMode.analysisRamsEnv} ramsOptions={ramsEnvOptions} header="Milieu" />
                    <RamsItem topLetter="P" ramsScore={this.props.failureMode.analysisRamsP} ramsOptions={ramsPOptions} header="Imago" />
                </PanelSection>
                {this.props.failureMode.analysisRemarks && (
                    <PanelSection>{htmlHelper.newLineToBreak(this.props.failureMode.analysisRemarks)}</PanelSection>
                )}
                {this.props.failureMode.analysisVerificationQuestion && (
                    <PanelSection>
                        <strong>{this.props.t('failureMode.analysisVerificationQuestion')}: </strong>
                        {htmlHelper.newLineToBreak(this.props.failureMode.analysisVerificationQuestion)}
                    </PanelSection>
                )}
            </DataPanel>
        );
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
export const ConditionReportFMECAAnalysis = translate()(ConditionReportFmecaAnalysisComponent);
